/* Real Shopify batch additions. Kaching alone owns gift insertion and discounts. */
window.CTCart = {
  async add(items, source, beforeOpen) {
    const root = window.Shopify?.routes?.root || '/';
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
    let added = false;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'These items could not be added.');
      added = true;
      const kaching = document.querySelector('kaching-cart');
      if (kaching && !window.__kachingCartDisabled && !window.__kachingCartFailedModuleLoad) {
        beforeOpen?.();
        document.dispatchEvent(new CustomEvent('kaching-cart:open', { detail: { element: source, cartOpenSource: 'cart-button' } }));
      } else {
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart refresh failed');
        const cart = await response.json();
        // Horizon listens for cart:update; use its own cart section markup and totals.
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer) beforeOpen?.();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
          resource: cart, sourceId: source.id || 'ct-add', data: { source: 'ct-add', itemCount: cart.item_count, sections: result.sections || {} },
        } }));
        // An auto-open Horizon drawer already scheduled its opening for this event.
        if (drawer && !drawer.hasAttribute('auto-open')) drawer.open?.();
      }
      return 'Added to your bag.';
    } catch (error) {
      // Never retry an ambiguous cart POST: the first request may have succeeded.
      if (added) return 'Added to your bag. Use View bag to check your items; the drawer could not refresh.';
      throw new Error(`${error.message || 'Connection interrupted.'} Check View bag before trying again.`);
    }
  },
};

class CTOutfit extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.form = this.querySelector('form');
    this.pieces = [...this.querySelectorAll('[data-ct-piece]')];
    this.button = this.querySelector('[type="submit"]');
    this.label = this.querySelector('[data-ct-button-label]');
    this.status = this.querySelector('[data-ct-status]');
    this.originalLabel = this.label.textContent;
    this.form.addEventListener('change', () => this.updatePrices(), { signal: this.controller.signal });
    this.form.addEventListener('submit', event => this.addOutfit(event), { signal: this.controller.signal });
    this.updatePrices();
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  money(cents) {
    return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD', currencyDisplay: 'code' }).format(cents / 100);
  }
  updatePrices() {
    let total = 0, eligibleTotal = 0, complete = true, selected = 0;
    this.pieces.forEach(piece => {
      const check = piece.querySelector('[data-ct-include]');
      const select = piece.querySelector('[data-ct-variant]');
      const quantity = piece.querySelector('[data-ct-quantity]');
      const included = check.checked && !check.disabled;
      select.disabled = quantity.disabled = !included;
      select.required = included;
      piece.dataset.included = String(included);
      const option = select.selectedOptions[0];
      if (option?.dataset.money) piece.querySelector('[data-ct-piece-price]').textContent = option.dataset.money;
      if (!included) return;
      selected++;
      if (!select.value || option.disabled) complete = false;
      const price = select.value && !option.disabled ? Number(option.dataset.price) : Number(piece.dataset.basePrice);
      total += price;
      if (piece.dataset.giftEligible === 'true' && select.value && !option.disabled) eligibleTotal += price;
    });
    this.querySelector('[data-ct-total]').textContent = (complete ? '' : 'From ') + this.money(total);
    this.button.disabled = this.busy || selected === 0;
    const message = this.querySelector('[data-ct-gift-message]');
    if (!message) return;
    const threshold = Number(this.dataset.giftThreshold);
    if (this.dataset.currency !== 'USD' || !Number.isFinite(threshold) || threshold <= 0) {
      message.textContent = 'Free Steel Relic Necklace';
    } else if (!complete || selected === 0) {
      message.textContent = 'Choose your sizes to check gift eligibility';
    } else if (eligibleTotal >= threshold) {
      message.textContent = 'Selected apparel qualifies for a free Steel Relic Necklace';
    } else {
      message.textContent = `${this.money(threshold - eligibleTotal)} in qualifying apparel away from your free Steel Relic Necklace`;
    }
  }
  async addOutfit(event) {
    event.preventDefault();
    if (this.busy || !this.form.reportValidity()) return;
    const selects = this.pieces.filter(p => p.querySelector('[data-ct-include]').checked && !p.querySelector('[data-ct-include]').disabled).map(p => p.querySelector('[data-ct-variant]'));
    if (!selects.length || selects.some(s => !s.value || s.selectedOptions[0].disabled)) return;
    this.busy = true; this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true'); this.label.textContent = 'Adding…';
    this.status.textContent = ''; this.status.dataset.error = 'false';
    try {
      this.status.textContent = await window.CTCart.add(selects.map(s => ({ id: Number(s.value), quantity: 1 })), this.button);
    } catch (error) { this.status.dataset.error = 'true'; this.status.textContent = error.message; }
    finally {
      this.busy = false; this.button.removeAttribute('aria-busy'); this.label.textContent = this.originalLabel; this.updatePrices();
    }
  }
}
if (!customElements.get('ct-outfit')) customElements.define('ct-outfit', CTOutfit);
